module.exports = __webpack_public_path__ + "img/p29192.ab83289f.jpg";